export default __webpack_public_path__ + "static/media/chopin-piano-raindrops.5b67e8c7.jpeg";